<template>
  <div class="productList" style="padding-top: 1rem" ref="container">
    <navTitle
      :title="
        $router.app._route.query.ti
          ? $router.app._route.query.ti
          : 'The Luck Cornucopia'
      "
      path="/"
    ></navTitle>

    <!--<form @submit.prevent="submitForm">-->
      <!--<div class="search  acea-row row-between-wrapper">-->
        <!--<div class="input acea-row row-between-wrapper">-->
          <!--<span class="iconfont icon-sousuo"></span>-->
          <!--<input placeholder="Search for product information" v-model="where.keyword" />-->
        <!--</div>-->
        <!--<div-->
          <!--class="iconfont"-->
          <!--style="color: #333"-->
          <!--:class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'"-->
          <!--@click="switchTap"-->
        <!--&gt;</div>-->
      <!--</div>-->
    <!--</form>-->
    <div class="nav-tab">
      <div class="item" @click="selectTab=0" :class="selectTab==0?'act':''">
        Goods list
      </div>
      <div class="item"  @click="selectTab=1" :class="selectTab==1?'act':''">
        My order
      </div>
    </div>
    <!--<Loading style="position: absolute;left: 0;right: 0;margin:  1.2rem auto;" :loaded="loadend" :loading="loading"></Loading>-->

    <!--商品列表-->
    <div
            v-show="selectTab==0"
      class="list acea-row row-between-wrapper"
      style="margin-top: 1.2rem"
      :class="Switch === true ? '' : 'on'"
      ref="container"
    >
      <router-link
        :to="{
          path: '/raiders/detail/' + item.id
        }"
        class="item"
        :class="Switch === true ? '' : 'on'"
        v-for="(item, index) in productList"
        :key="index"
        :title="item.store_name"
      >
        <div class="pictrue" :class="Switch === true ? '' : 'on'">
          <img :src="item.image" :class="Switch === true ? '' : 'on'" />
        </div>
        <div class="text" :class="Switch === true ? '' : 'on'">
          <div class="name line1">{{ item.name }}</div>
          <div class="progress" :class="Switch === true ? '' : 'onProgress'">
            <div class="row">
              <div>Total:{{item.now_game.total}}</div>
              <div>Residue:{{item.now_game.total - item.now_game.num>=0?item.now_game.total - item.now_game.num:0}}</div>
            </div>
            <div class="bar">
              <div class="mind" :style="{width:((item.now_game.num/item.now_game.total)*100)+'%'}"></div>
            </div>
          </div>

        </div>
      </router-link>
    </div>
    <!--订单列表-->
    <div
            v-show="selectTab==1"
            class="list acea-row row-between-wrapper"
            style="margin-top: 1.2rem"
            :class="Switch === true ? '' : 'on'"
            ref="container"
    >
     <div class="orderList" v-for="(item, index) in orderList" :key="index">
       <div class="item">
         <div class="item-row" style="display: flex;justify-content: space-between;border-bottom: 1px solid #eee">
           <div class="">{{item.pay_time}}</div>
           <div :class="item.status==0?'':item.status==1?'green':'red'">{{item.status==0?'Waiting for the lottery':item.status==1?'Winning':'Failure'}}</div>
         </div>
         <div class="item-row">Order id: {{item.order_id}}</div>
         <div class="item-row">game name: {{item.game_name}}</div>

         <div class="item-row">issue id: {{item.issue_num}}</div>
         <div class="item-row">Purchase quantity: {{item.num}}</div>
         <div class="item-row"  v-if="item.status==1">
           <img  class="congratulations" src="../../../assets/images/icon_growsystem_upgrade_congratulations.png" alt="">
         </div>



       </div>
     </div>
    </div>

    <div class="noCommodity" v-if="productList.length === 0 && where.page > 1">
      <div class="noPictrue">
        <img src="@assets/images/noGood.png" class="image" />
      </div>
    </div>

    <!--<Recommend v-if="productList.length === 0 && where.page > 1"></Recommend>-->
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import navTitle from "@components/navTitle";
import { getList,getOrder } from "@api/raiders";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";

export default {
  name: "RaidersIndex",
  components: {
    Recommend,
    Loading,
    navTitle
  },
  props: {},
  data: function() {
    const { s = "",  title = "" } = this.$route.query;

    return {
      hostProduct: [],
      productList: [],
      selectTab:0,
      orderList:[],
      Switch: true,
      where: {
        page: 1,
        limit: 8,
        keyword: s,
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false
    };
  },
  watch: {
    title() {
      this.updateTitle();
    },
    selectTab(n){
      console.log(n)
      this.loading = false
      this.loadend = false
      this.get_product_list();
    },
    $route(to) {
      if (to.name !== "GoodsList") return;

      this.selectTab = to.params.id;

      const { s = "", id = 0, title = "" } = to.query;

      if (s !== this.where.keyword || id !== this.where.sid) {
        this.where.keyword = s;
        this.loadend = false;
        this.loading = false;
        this.where.page = 1;
        this.where.sid = id;
        this.title = title && id ? title : "";
        this.nows = false;
        this.$set(this, "productList", []);
        this.price = 0;
        this.stock = 0;
        this.get_product_list();
      }
    }
  },
  mounted: function() {
    this.selectTab = this.$route.params.id;

    this.updateTitle();
    this.get_product_list();

  },
  methods: {
    updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    get_product_list(){
      var that = this;
      this.$dialog.loading.open('loading...')

      getList({}).then(res => {
        that.loading = false;
        that.$dialog.loading.close()
        that.productList =  res.data
      })
              .catch(res=>{
                that.$dialog.loading.close();
                that.$dialog.error(res.msg || "error")
              })
      getOrder({page:1,limit:999}).then(res=>{
        this.orderList = res.data
      })
    }
  }
};
</script>
<style scoped>
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
  .progress{
    width: 100%;
    font-size: 0.25rem;
  }
  .onProgress{
    position: absolute;
    bottom: 0.22rem;
    left: 0.22rem;
  }
  .progress .row{
    display: flex;
    justify-content: space-between;
  }
  .progress .bar{
    width: 100%;
    height:10px;
    border-radius: 15px;
    background: #F3F3F3;
  }
  .progress .bar .mind{
    width: 0%;
    max-width: 100%;
    height: 10px;
    border-radius: 15px;
    background: #FFB903;
  }

  .nav-tab{
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    background: #fff;
    display: flex;
    border-top: 1px solid #f0f0f0;
    position: fixed;
    top: 1rem;
    left: 0px;
    z-index: 2000;
  }

  .nav-tab .item{
    width: 50%;
  }
  .nav-tab .act{
    border-bottom: 2px solid #00c3f9;
  }

  .orderList{
    width: 100%;
    color: #333;
  }
  .orderList .item{
    padding: 0.14rem 0.28rem;
    box-sizing: border-box;
    /*border-bottom: 1px dashed #ccc;*/
    width: 100%;
    margin-bottom: 0.28rem;
    background: #fff;
    box-shadow: 0 5px 5px #eeeeee;
    border-radius: 3px;

  }
  .orderList .item .item-row{
    width: 100%;
    line-height: 0.6rem;
    height: 0.6rem;
    display: flex;
  }

  .red{
    color: #ff3c2b;
  }
  .green{
    color: #1abb1d;
  }
  .congratulations{
    width: 3.4rem;
    height: 0.6rem;
    transform: scale(0.9);
    margin: 0 auto;
  }
</style>
